import styled from 'styled-components';

export default styled.form`
  width: 100%;
  margin-bottom: -12px;
  h3 {
    margin-bottom: 12px;
    margin-top: 52px;
  }
  label {
    display: block;
    margin-bottom: 3px;
    font-weight: 600;
    opacity: 0.6;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Form.js